module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_GIFRER.253db85f.png";